import {
  faAlignLeft,
  faSquare,
  faSquareCheck,
} from '@fortawesome/pro-regular-svg-icons';
import { faCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tag } from '@rocketlane/ui';
import {
  NodeViewProps,
  Node as TiptapNode,
  mergeAttributes,
} from '@tiptap/core';
import { NodeViewContent, ReactNodeViewRenderer } from '@tiptap/react';
import { NodeViewWrapper } from '@tiptap/react';
import styled from 'styled-components';

const StyledTag = styled(Tag)``;

const PlaceholderConfigNodeView = ({ node }: NodeViewProps) => {
  const Icon = () => {
    switch (node.attrs.icon) {
      case 'faCircle':
        return <FontAwesomeIcon icon={faCircle} style={{ fontSize: '4px' }} />;
      case 'faAlignLeft':
        return <FontAwesomeIcon icon={faAlignLeft} />;
      case 'faSquare':
        return <FontAwesomeIcon icon={faSquare} />;
      case 'faSquareCheck':
        return <FontAwesomeIcon icon={faSquareCheck} />;
    }

    return <></>;
  };

  return (
    <NodeViewWrapper contentEditable={false}>
      <StyledTag className="mt-1" color="gray" variant="basic" icon={<Icon />}>
        <div>
          <NodeViewContent />
        </div>
      </StyledTag>
    </NodeViewWrapper>
  );
};

export const RlPlaceholderConfigName = 'RL_PLACEHOLDER_CONFIG';

export const RlPlaceholderConfig = TiptapNode.create({
  name: RlPlaceholderConfigName,

  group: 'block',
  inline: false,
  atom: false,
  selectable: false,
  draggable: false,

  content: 'inline*',

  addAttributes() {
    return {
      icon: {
        default: '',
      },
      iconPosition: {
        default: 'left',
      },
      disabled: {
        default: false,
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: `placeholder-config[data-type="${this.name}"]`,
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'placeholder-config',
      mergeAttributes(HTMLAttributes, {
        ['data-type']: this.name,
        contenteditable: 'false',
      }),
    ];
  },

  addNodeView() {
    return ReactNodeViewRenderer(PlaceholderConfigNodeView);
  },
});
